import { CSSObject } from "@emotion/react";
import { constants } from "@newsela/angelou";

import { NAVBAR_BREAKPOINTS } from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/constants";

export const appSwitcherPopoutContainerCss: CSSObject = {
  display: "flex",
  flexDirection: "column",
  padding: "1rem 1rem 1rem 0.5rem !important",
  gap: "0.25rem",
  background: constants.colors.ui.neutral[700],
  borderRadius: "0.5rem",
  boxShadow: "0px 2px 6px 0px rgba(29, 29, 29, 0.16)",
  width: "18.75rem",

  [`@media (max-width: ${NAVBAR_BREAKPOINTS.sm}px)`]: {
    width: "inherit",
    borderRadius: "0 0 0.5rem 0.5rem",
  },
};
